<template>
  <div class="attachments">
    <h3 class="attachments__title">
      <span>{{ title }}</span>

      <v-btn
        v-if="attachments && attachments.length && !readonly"
        class="attachments__add-btn"
        outlined
        fab
        tile
        x-small
        color="primary"
        @click="openAttachmentsModal"
      >
        <v-icon color="blue">mdi-plus-thick</v-icon>
      </v-btn>
    </h3>

    <template v-if="attachments && attachments.length">
      <div
        v-for="(attachment, index) in attachments"
        :key="index"
        class="attachments__element"
      >
        <div class="attachments__file">
          <v-btn
            class="attachments__icon"
            tile
            fab
            dark
            x-small
            depressed
            color="blue-light"
          >
            <v-icon color="blue">mdi-file</v-icon>
          </v-btn>
          <span class="attachments__filename">
            {{ attachment.filename }}
          </span>
        </div>

        <div class="attachments__actions">
          <div class="text-right">
            <v-btn
              v-if="!readonly"
              class="attachments__delete"
              color="primary"
              outlined
              tile
              fab
              x-small
              depressed
              @click="deleteAttachment(attachment.id)"
            >
              <v-icon color="primary">mdi-delete</v-icon>
            </v-btn>

            <v-btn
              class="attachments__delete"
              color="blue"
              link
              :href="attachment.url"
              target="_blank"
              outlined
              tile
              fab
              x-small
              depressed
            >
              <v-icon color="blue">mdi-download</v-icon>
            </v-btn>
          </div>
          <div
            v-if="!readonly && isDeveloperProfile"
            class="developer-attachments__visibility text-right"
          >
            Visible for clients
            <v-switch
              :input-value="attachment.client_visibility"
              :disabled="processing"
              class="switch-custom mt-1 ml-3"
              inset
              dense
              hide-details
              color="blue"
              @change="changeAttachmentVisibility(attachment)"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <EmptyState
        title="Would you like to add attachment?"
        :description="emptyStateDescription"
        outlined
        @click="openAttachmentsModal"
      />
    </template>
  </div>
</template>

<script>
import EmptyState from '@/components/Developers/Show/EmptyState.vue';

export default {
  components: {
    EmptyState,
  },

  props: {
    attachments: {
      type: Array,
      required: true,
    },

    processing: {
      type: Boolean,
      required: false,
      default: false,
    },

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },

    isDeveloperProfile: {
      type: Boolean,
      required: false,
      default: false,
    },

    title: {
      type: String,
      required: false,
      default: 'Additional files',
    },
  },

  data() {
    return {
      emptyStateDescription: this.isDeveloperProfile ? 'Add as many of your skills as possible so more recruiters can find you.' : '',
    };
  },

  methods: {
    deleteAttachment(id) {
      this.$emit('delete', id);
    },

    openAttachmentsModal() {
      this.$emit('edit');
    },

    changeAttachmentVisibility(attachment) {
      this.$emit('visibility-toggle', attachment);
    },
  },
};
</script>

<style lang="scss" scoped>
.attachments {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $main--headers;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__add-btn {
    border-radius: 4px;
    border-color: $color--secondary;
  }

  &__element {
    line-height: 20px;
    margin-top: 16px;
    position: relative;
    display: flex;

    &:hover .attachments__delete {
      opacity: 1;
    }

    &:hover .attachments__visibility {
      opacity: 1;
      display: flex;
      height: unset;
    }
  }

  &__filename {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    color: $main--text;
    word-break: break-word;

  }

  &__element-title {
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 0px;
  }

  &__icon {
    border-radius: 8px;
    margin-right: 16px;
    cursor: default;
  }

  &__actions {
    margin-left: auto;
  }

  &__delete {
    border-radius: 4px;
    border-color: $color--secondary;
    margin-left: 8px;
    opacity: 0;
  }

  &__visibility {
    height: 0;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #434550;
    opacity: 0;
    display: none;
    align-items: center;
  }
}
</style>
